import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
import { VersionEvent } from '../types';
const StatusVariants = {
    inspection: {
        label: 'status',
        icon: 'status_icon',
        color: 'status_color'
    },
    workOrder: {
        label: 'work_order_status',
        icon: 'work_order_status_icon',
        color: 'work_order_status_color'
    },
    deficiency: {
        label: 'status',
        icon: 'deficiency_status_icon',
        color: 'deficiency_status_color'
    },
    visit: {
        label: 'visit_status_name',
        icon: 'visit_status_icon',
        color: 'visit_status_color'
    }
};
function getStatusFromVariant(variant, changes) {
    // Filter changes to only include keys that match status-related properties (label, icon, color)
    // for the given variant (inspection or workOrder). This ensures we only process
    // status-related changes and ignore other unrelated changes.
    const statusInfo = Object.entries(changes).filter(([key]) => Object.values(StatusVariants[variant]).includes(key));
    if (statusInfo.length === 0) {
        return null;
    }
    return statusInfo.reduce((acc, [key, [oldValue, newValue]]) => {
        if (key === StatusVariants[variant].label) {
            acc[0].label = snakeToCapitalize(String(oldValue));
            acc[1].label = snakeToCapitalize(String(newValue));
        }
        if (key === StatusVariants[variant].icon) {
            acc[0].icon = String(oldValue);
            acc[1].icon = String(newValue);
        }
        if (key === StatusVariants[variant].color) {
            acc[0].color = String(oldValue);
            acc[1].color = String(newValue);
        }
        return acc;
    }, [
        { label: '', icon: '', color: '' },
        { label: '', icon: '', color: '' }
    ]);
}
export default function getStatusUpdate(activity) {
    if ('notes' in activity) {
        return null;
    }
    const version = activity;
    if (version.event === VersionEvent.Create) {
        return null;
    }
    const inspectionStatus = getStatusFromVariant('inspection', version.changes);
    const workOrderStatus = getStatusFromVariant('workOrder', version.changes);
    const deficiencyStatus = getStatusFromVariant('deficiency', version.changes);
    const visitStatus = getStatusFromVariant('visit', version.changes);
    return inspectionStatus || workOrderStatus || deficiencyStatus || visitStatus;
}
